import React, { useState } from "react";
import { Button, Typography, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { AnimatePresence } from "framer-motion";
import {
  useCreateData,
  useDeleteTableDataPreset,
  useGetTableData2,
} from "../Plan/tableHooks";
import NewPresetForm from "./NewPresetForm";
import PresetCard from "./PresetCard";
import * as S from "./styles";
import goToHelpLink from "../../../utils/goToHelpLink";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

function Preset({ openSnackbar, group_code, project_code }) {
  const { presets } = useGetTableData2(
    true,
    `/api/factory/getTypeM?group_code=${group_code}&project_code=${project_code}`,
    "presets"
  );
  const createMutation = useCreateData(
    true,
    "/api/factory/createPreset",
    openSnackbar
  );
  const editMutation = useCreateData(
    true,
    "/api/factory/postType",
    openSnackbar
  );
  const deletePresetMutation = useDeleteTableDataPreset(
    true,
    "/api/factory/deletePreset",
    true
  );
  const [isCreating, setIsCreating] = useState(false);
  const [editingPreset, setEditingPreset] = useState(null);
  return (
    <S.PageWrapperPreset maxWidth={false}>
      <S.HeaderPreset>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontWeight: "700",
              fontSize: "22px !important",
              color: "#111",
            }}
          >
            가동 시간 프리셋&nbsp;
          </Typography>
          <Tooltip
            title="이동"
            sx={{ cursor: "pointer" }}
            onClick={() =>
              goToHelpLink(
                "https://help.ese-tech.com/ko/scheduler#h-9-1-%ED%94%84%EB%A6%AC%EC%85%8B-%EC%84%A4%EC%A0%95"
              )
            }
          >
            <HelpOutlineIcon />
          </Tooltip>
        </div>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setIsCreating(true)}
          disabled={isCreating}
        >
          새 프리셋
        </Button>
      </S.HeaderPreset>
      <S.PresetsList>
        <AnimatePresence>
          {isCreating && (
            <NewPresetForm
              createMutation={createMutation}
              setIsCreating={setIsCreating}
              openSnackbar={openSnackbar}
              group_code={group_code}
              project_code={project_code}
            />
          )}
        </AnimatePresence>
        {presets
          .filter((preset) => preset.id > 0)
          .map((preset) => (
            <PresetCard
              key={preset.id}
              preset={preset}
              editingPreset={editingPreset}
              setEditingPreset={setEditingPreset}
              editMutation={editMutation}
              deletePresetMutation={deletePresetMutation}
              openSnackbar={openSnackbar}
              group_code={group_code}
              project_code={project_code}
            />
          ))}
      </S.PresetsList>
    </S.PageWrapperPreset>
  );
}

export default Preset;
